// Canonical Tailwind class strings for shared UI primitives (light default + dark: variants).
// Dark mode uses solid slate surfaces — no white/ glass borders.

const BTN_BASE =
  'inline-flex items-center justify-center rounded-lg border font-semibold whitespace-nowrap select-none disabled:cursor-not-allowed transition-all duration-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40';

export const BTN_PRIMARY =
  `${BTN_BASE} h-9 px-3 text-xs bg-blue-600 text-white border-blue-700 hover:bg-blue-700 disabled:bg-blue-200 disabled:border-blue-200 disabled:text-white`
  + ' dark:bg-blue-600 dark:border-blue-500/40 dark:hover:bg-blue-500 dark:disabled:bg-slate-800 dark:disabled:border-slate-700 dark:disabled:text-slate-500';

export const BTN_PRIMARY_SM =
  `${BTN_BASE} h-8 px-2.5 text-[11px] bg-blue-600 text-white border-blue-700 hover:bg-blue-700 disabled:bg-blue-200 disabled:border-blue-200 disabled:text-white`
  + ' dark:bg-blue-600 dark:border-blue-500/40 dark:hover:bg-blue-500 dark:disabled:bg-slate-800 dark:disabled:border-slate-700 dark:disabled:text-slate-500';

export const BTN_SECONDARY =
  `${BTN_BASE} h-9 px-3 text-xs bg-white text-gray-900 border-gray-300 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400`
  + ' dark:h-8 dark:px-2.5 dark:text-[11px] dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:hover:bg-slate-700 dark:hover:text-slate-50 dark:disabled:bg-slate-900 dark:disabled:text-slate-500';

export const BTN_SECONDARY_SM =
  `${BTN_BASE} h-8 px-2.5 text-[11px] bg-white text-gray-900 border-gray-300 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400`
  + ' dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:hover:bg-slate-700 dark:disabled:bg-slate-900 dark:disabled:text-slate-500';

export const BTN_GHOST =
  `${BTN_BASE} h-9 px-3 text-xs bg-transparent text-gray-700 border-transparent hover:bg-gray-100 disabled:text-gray-400`
  + ' dark:text-slate-200 dark:hover:bg-slate-800 dark:disabled:text-slate-500';

export const BTN_DANGER =
  `${BTN_BASE} h-9 px-3 text-xs bg-red-600 text-white border-red-700 hover:bg-red-700 disabled:bg-red-200 disabled:border-red-200 disabled:text-white`
  + ' dark:bg-red-600 dark:border-red-500/40 dark:hover:bg-red-500 dark:disabled:bg-slate-800 dark:disabled:border-slate-700 dark:disabled:text-slate-500';

export const BTN_DARK =
  `${BTN_BASE} h-8 px-2.5 text-[11px] bg-slate-900 text-white border-slate-700 hover:bg-slate-800 disabled:bg-slate-800 disabled:border-slate-700 disabled:text-slate-500`
  + ' dark:bg-slate-800 dark:border-slate-600 dark:hover:bg-slate-700';

export const BTN_ICON =
  'inline-flex items-center justify-center h-9 w-9 rounded-lg border border-gray-300 bg-white text-gray-600 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-800 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition-all duration-100'
  + ' dark:h-8 dark:w-8 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-slate-100 dark:disabled:text-slate-600';

export const INPUT =
  'h-9 w-full min-w-0 px-3 text-xs rounded-lg border border-gray-300 dark:border-slate-600 bg-white text-gray-900 placeholder:text-gray-400 dark:placeholder:text-slate-500 transition-colors duration-100'
  + ' focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:bg-gray-50 disabled:text-gray-400'
  + ' dark:h-8 dark:px-2.5 dark:text-[11px] dark:bg-slate-900 dark:border-slate-600 dark:text-slate-100 dark:placeholder:text-slate-500'
  + ' dark:focus:border-blue-500 dark:focus:ring-blue-500/25 dark:disabled:bg-slate-950 dark:disabled:text-slate-600';

export const INPUT_SM =
  'h-8 w-full min-w-0 px-2.5 text-[11px] rounded-lg border border-gray-300 dark:border-slate-600 bg-white text-gray-900 placeholder:text-gray-400 dark:placeholder:text-slate-500 transition-colors duration-100'
  + ' focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:bg-gray-50 disabled:text-gray-400'
  + ' dark:bg-slate-900 dark:border-slate-600 dark:text-slate-100 dark:placeholder:text-slate-500'
  + ' dark:focus:border-blue-500 dark:focus:ring-blue-500/25';

export const SELECT =
  'h-9 w-full min-w-0 px-3 pr-8 text-xs rounded-lg border border-gray-300 dark:border-slate-600 bg-white text-gray-900 transition-colors duration-100'
  + ' focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:bg-gray-50 disabled:text-gray-400'
  + ' dark:bg-slate-900 dark:border-slate-600 dark:text-slate-100 dark:focus:border-blue-500 dark:disabled:bg-slate-950 dark:disabled:text-slate-600';

export const CHECKBOX =
  'h-3.5 w-3.5 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-200'
  + ' dark:border-slate-500 dark:bg-slate-900 dark:focus:ring-blue-500/30';

export const CHECKBOX_LABEL =
  'flex items-center gap-2 text-xs text-gray-600 select-none dark:text-slate-300';

export const CHIP =
  'inline-flex items-center gap-2 px-2.5 h-8 rounded-lg text-[11px] text-gray-700 border border-gray-200 bg-gray-50'
  + ' dark:text-slate-200 dark:bg-slate-800 dark:border-slate-600';

export const REQUEST_FILTER_CHIP =
  'inline-flex items-center gap-2 px-3 h-9 rounded-lg text-[11px] text-violet-700 border border-violet-200 bg-violet-50'
  + ' dark:text-violet-200 dark:bg-violet-950/50 dark:border-violet-700/50';

export const CARD_SURFACE =
  'rounded-xl border border-slate-300 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.06),0_4px_12px_-2px_rgba(15,23,42,0.08)] dark:border-slate-700 dark:bg-slate-900 dark:shadow-card-dark';

export const CARD_SURFACE_RAISED =
  'rounded-xl border border-slate-300 bg-slate-50 shadow-[0_1px_2px_rgba(15,23,42,0.06),0_4px_12px_-2px_rgba(15,23,42,0.08)] dark:border-slate-700 dark:bg-slate-800 dark:shadow-card-dark';

export const DIALOG_OVERLAY =
  'fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 sm:p-4 dark:bg-black/70';

/** Above race detail portal (z 5000) and workflow overlays (z 5100). */
export const DIALOG_OVERLAY_RACE_STACKED =
  'fixed inset-0 z-[5200] flex items-center justify-center bg-black/40 p-3 sm:p-4 dark:bg-black/70';

export const DIALOG_PANEL =
  'w-full max-w-xl overflow-y-auto rounded-xl border border-slate-300 bg-white shadow-xl dark:border-slate-700 dark:bg-slate-900 dark:shadow-dialog-dark max-h-[calc(100dvh-1.5rem)] sm:max-h-[calc(100dvh-3rem)]';

export const DIALOG_HEADER =
  'px-4 py-3 border-b border-gray-200 bg-gray-50 dark:border-slate-700 dark:bg-slate-800';

// Shared vertical gradient for tab bars, scope panels, and event card headers.
// Light mode uses the same multi-stop structure as dark (sky → wash → white) so the bar reads clearly on pale pages.
export const TAB_HEADER_GRADIENT_BG =
  'bg-gradient-to-b from-sky-100/90 via-sky-50/50 to-white dark:from-slate-800 dark:via-slate-900 dark:to-slate-950';

// Header bar that sits at the top of each main page/tab (Devices, Events, Logs, Admin).
// Light mode picks up a hint of brand blue (sky-50 → white) so the active tab/area
// reads as different from the page background; dark mode keeps the slate gradient.
export const PAGE_TAB_HEADER =
  `px-5 py-4 border-b border-slate-300 dark:border-slate-700 ${TAB_HEADER_GRADIENT_BG}`;

/** Event / race scope block on Devices (and similar inset panels). */
export const SCOPE_PANEL_SURFACE =
  `rounded-xl border border-slate-300 dark:border-slate-700 shadow-sm overflow-hidden ${TAB_HEADER_GRADIENT_BG}`;

/** Collapsed header strip on each Events overview card — rounded top to align with CARD_SURFACE clipping. */
export const EVENT_CARD_HEADER_SURFACE =
  `rounded-t-xl border-b border-slate-300 dark:border-slate-700 px-4 py-3 ${TAB_HEADER_GRADIENT_BG}`;

export const DIALOG_BODY = 'px-4 py-3 text-sm text-gray-800 dark:text-slate-100';

export const DIALOG_FOOTER =
  'px-4 py-3 border-t border-gray-200 bg-gray-50 flex items-center justify-end gap-2 dark:border-slate-700 dark:bg-slate-800';

export const BTN_BASE_LEGACY = BTN_BASE;
